<template>
  <div class="query">
    <div>
      <div class="error" v-show="dataFetchError">
        <p>Unable to fetch queries. Please try again.</p>
      </div>
    </div>

    <div class="query__header">
      <h1>Queries Center</h1>
    </div>

    <div class="page-loader" v-show="pageLoading">
      <div>
        <PageLoader />
      </div>
    </div>

    <div class="query__body" v-show="!pageLoading">
      <div class="query__div--content-body-enrol">
        <p v-if="queries.length">You can view all query that have been issued here:</p>
        <p v-else>No queries issued yet</p>

        <!-- <div class="query__div--content-body-enrol-filter">
          <div class="query__div--content-body-filter-left">
            Filter
            <font-awesome-icon icon="sort-amount-down-alt" />
          </div>
          <div class="query__div--content-body-filter-right">
            <Search />
          </div>
        </div>-->

        <div class="query__div--content-body-enrol-table">
          <div class="query__div--content-body-table-header">
            <div>Query Type</div>
            <div>Date Issued</div>
            <div>Status</div>
            <div class="small-hide"></div>
          </div>
          <div class="query__div--content-body-table-body">
            <div v-for="(query, index) in queries" :key="index" @click.prevent="viewQuery(query)">
              <div>{{query.title}}</div>
              <div>{{query.created_at}}</div>
              <div style="color: #f3826c;" v-if="query.status == 0">Pending</div>
              <div style="color: #1ec4b4;" v-if="query.status == 1">Issued</div>
              <div class="small-hide">
                <div>
                  <routerLink :to="{ name: 'ViewQuery', params: { id: query.id } }">
                    <div>View</div>
                  </routerLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="query__div"></div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";

export default {
  name: "Query",

  components: {
    PageLoader
  },

  data() {
    return {
      item: "queries",
      hr: "hr",
      queries: [],
      pageLoading: true,
      dataFetchError: false
    };
  },

  created() {
    this.getQueries();
  },

  mounted() {
    document.getElementById("offCanvas").checked = false;
  },

  methods: {
    getQueries() {
      this.$http
        .get(types.GET_EMPLOYEE_QUERY_API)
        .then(resp => {
          this.queries = resp.data.data.data;
          this.pageLoading = false;
        })
        .catch(err => {
          if (err.response) {
            this.dataFetchError = true;
          }
          this.pageLoading = false;
        });
    },

    viewQuery(query) {
      this.$store.state.query = this.queries;
      this.$router.push({ name: "ViewMyQuery", params: { id: query.id } });
    }
  }
};
</script>
<style lang="scss" scoped>
.page-loader {
  margin-top: 50px;

  > div {
    width: 55px;
    margin: auto;
  }
}

.error {
  margin-top: 10px;
  text-align: center;
  color: red;
  font-size: 12;
  font-style: italic;
  p {
    margin: 0;
    padding-bottom: 10px;
  }
  p::first-letter {
    text-transform: uppercase;
  }
}

.query {
  padding-top: 40px;
  padding-left: 3.125vw;
  padding-right: 3.125vw;

  .query__header {
    overflow: hidden;
    padding-bottom: 5px;

    > h1 {
      padding-bottom: 5px;
      margin-left: 15px;
      margin-top: 0;
      font-size: 2em;
      margin-left: 0;
      margin-bottom: 0;
    }

    > .query__header--btn {
      float: right;
      width: 200px;

      > div {
        width: 9.063vw;
        height: 38px;
        border-radius: 2px;
        background-color: #5099de;
        float: right;
        font-size: 0.938vw;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.22;
        letter-spacing: normal;
        text-align: left;

        > a {
          color: #ffffff;
          text-decoration: none;
          > div {
            height: 38px;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
          }
        }
      }
    }
  }

  > .query__body {
    border-top: 1px solid #caced5;
    padding: 20px 5px 0 5px;

    > .query__div--content-body-enrol {
      margin-bottom: 50px;
      > p {
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
        margin-bottom: 50px;
      }

      .query__div--content-body-enrol-filter {
        overflow: hidden;
        > .query__div--content-body-filter-left {
          width: 120px;
          height: 35px;
          border-radius: 2px;
          border: solid 1px #caced5;
          background-color: #ffffff;
          float: left;
          margin-right: 20px;
          font-size: 0.833vw;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.19;
          letter-spacing: normal;
          text-align: left;
          color: #777777;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
        }

        > .query__div--content-body-filter-right {
          width: 200px;
          height: 35px;
          border-radius: 2px;
          background-color: #ffffff;
          float: left;
        }
      }

      > .query__div--content-body-enrol-table {
        margin-top: 30px;
        > .query__div--content-body-table-header {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;

          > div {
            width: 20%;
            text-align: center;
            font-size: 1.042vw;
            font-weight: 500;
            font-style: normal;
            font-stretch: normal;
            line-height: 1;
            letter-spacing: normal;
            color: #000000;
          }
        }

        .query__div--content-body-table-body {
          border-top: 5px solid #5099de;
          margin-top: 20px;

          > div {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
            height: 76px;
            margin-bottom: 20px;
            background-color: #ffffff;
            border-radius: 2px;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
            cursor: pointer;

            > div {
              width: 20%;
              text-align: center;
              font-size: 1.042vw;
              font-weight: 500;
              font-style: normal;
              font-stretch: normal;
              line-height: 1;
              letter-spacing: normal;
              color: #000000;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
              align-content: center;

              > div {
                width: 4.948vw;
                height: 38px;
                border-radius: 2px;
                border: solid 1px #5099de;
                font-size: 0.625vw;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.67;
                letter-spacing: normal;
                text-align: center;
                margin: auto;
                cursor: pointer;
                overflow: hidden;

                > a {
                  text-decoration: none;
                  color: #000;
                  > div {
                    height: 38px;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    align-items: center;
                    justify-content: center;
                    align-content: center;
                  }
                }
              }
            }
          }
        }
      }
    }

    > .query__div--content-body-paginate {
      border: 1px solid red;
      width: 20.833vw;
      margin: auto;
      height: 40px;
      border-radius: 4px;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.05);
      border: solid 1px #d7dae2;
      background-color: #ffffff;
      margin-bottom: 150px;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;

      > .query__div--content-body-paginate-prev {
        width: 20%;
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: normal;
        text-align: center;
        color: #5099de;
        height: 40px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        cursor: pointer;
      }

      > .query__div--content-body-paginate-page {
        width: 60%;
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: normal;
        text-align: center;
        color: #000;
        height: 40px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        cursor: pointer;

        > div {
          width: 20%;
          height: 40px;
          border: solid 1px #d7dae2;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
        }
      }

      > .query__div--content-body-paginate-next {
        width: 20%;
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: normal;
        text-align: center;
        color: #000;
        height: 52px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        cursor: pointer;
      }
    }
  }
}

@media (max-width: 760px) {
  .query__div--content-body-table-header {
    > div {
      font-size: 10px !important;
    }
  }

  .query__div--content-body-table-body {
    > div {
      > div {
        font-size: 10px !important;
        margin: 0 15px 0 15px;
      }
    }
  }

  .small-hide {
    display: none !important;
  }
}
</style>
